<template>
    <Modal :title="translate('labels.create_integration_filter_item')" ref="Modal">
        <div class="modal-body">
            <FormGroup :label="`${translate('labels.name')} (${$t(`languages.${integrationLanguage}`)})`" v-for="integrationLanguage in languageAliasesByFilterType" :required="true">
                <slot v-if="externalFilter?.source_id === null || (externalFilter?.source_id !== null && externalFilter?.allow_custom_values)">
                    <Input
                        v-model="names[integrationLanguage]"
                        :type="externalFilter?.type === 'number' ? 'number' : 'text'"
                    />
                    <span v-if="externalFilter?.type === 'number' && (externalFilter?.min_number_value !== null || externalFilter?.max_number_value !== null)" class="form-text text-muted">
                        <span v-if="externalFilter?.min_number_value !== null">
                            {{ $t('labels.min') }}: {{ externalFilter?.min_number_value }}
                        </span>
                        <span v-if="externalFilter?.max_number_value !== null">
                            <span v-if="externalFilter?.min_number_value !== null"> - </span>
                            {{ $t('labels.max') }}: {{ externalFilter?.max_number_value }}
                        </span>
                    </span>
                </slot>
                <slot v-else>
                    <Autocomplete
                        @update:model-value="newFilterItem => selectRozetkaFilterItem(newFilterItem, integrationLanguage)"
                        :model-value="names[integrationLanguage]"
                        :selected-value="names[integrationLanguage]"
                        :url="`/projects/${$route.params.projectUuid}/marketplace/sources/${integration.service}/categories/${externalCategory?.source_id}/attributes/${externalFilter.source_id}/items`"
                        :query-params="{
                            category_parent_id: externalCategory?.parent_source_id,
                            orders: [{column: `name_${integrationLanguage}`, dir: 'asc'}]
                        }"
                        option-key="source_id"
                        :option-value="`name_${integrationLanguage}`"
                        :not-found-alert-texts="{
                            category: $t('alerts.marketplace_category_not_found'),
                            attribute: $t('alerts.marketplace_attribute_not_found')
                        }"
                    />
                </slot>
            </FormGroup>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="teal" @click="createExternalFilterItem" :disabled="!allLanguagesIsFilled">
                {{ translate('buttons.create') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../components/new/modal/AppModal.vue'
import FormGroup from '../../../../components/new/form/group/FormGroup.vue'
import Input from '../../../../components/new/form/Input.vue'
import Button from '../../../../components/new/button/AppButton.vue'
import Autocomplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue'
import Alert from '../../../../components/AlertComponent.vue'

import { httpClient } from '../../../../services/HttpClient'
import { getServicesWhoNeedAdditionalRequest } from '../../../enums/IntegrationServiceEnum';

export default {
    name: "CreateIntegrationFilterItemModal",
    components: {
        Modal, FormGroup, Input, Button, Autocomplete, Alert
    },
    props: {
        integration: {
            type: Object,
            required: true
        },
        externalCategory: {
            type: [Object, null]
        }
    },
    data() {
        return {
            names: {},
            filterIndex: null,
            filterItemIndex: null,
            sourceId: null,
            externalFilter: null,
            filterItemIsEmpty: {},
            servicesWhoNeedAdditionalRequest: getServicesWhoNeedAdditionalRequest()
        }
    },
    emits: ['created'],
    methods: {
        getCategorySourceId() {
            if (!this.externalCategory?.source_id) {
                return null;
            }

            if (String(this.externalCategory.source_id).includes('-')) {
                return Number(String(this.externalCategory.source_id).split('-')[0]);
            }

            return this.externalCategory.source_id;
        },
        hide() {
            this.$refs.Modal.hide();
            this.names = {}
            this.filterIndex = null
            this.filterItemIndex = null
            this.externalFilter = null
            this.marketplaceCategoryUuid = null
            this.marketplaceFilterUuid = null
        },
        async createExternalFilterItem() {
            let requestData = {
                integration_filter_uuid: this.externalFilter.uuid
            };

            if (this.externalFilter?.type === 'number') {
                requestData.names = {}

                for (let languageAlias of this.integration.language_aliases) {
                    requestData.names[languageAlias] = this.names[languageAlias] || this.names[this.mainLanguageAlias] || '';
                }
            } else {
                requestData.names = this.names
            }

            if (this.sourceId !== null) {
                requestData.source_id = this.sourceId
            }

            if (this.servicesWhoNeedAdditionalRequest.includes(this.integration.service)) {
                requestData.source_id = this.sourceId
            }

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filter-items`, requestData).then((response) => {
                this.$emit('created', {filterItem: response.data.data, filterIndex: this.filterIndex, filterItemIndex: this.filterItemIndex})
            })

            this.hide()
        },
        selectRozetkaFilterItem(filterItem) {
            this.integration.language_aliases.forEach(lang => {
                if (!filterItem[`name_${lang}`]) {
                    return
                }
                
                this.names[lang] = filterItem[`name_${lang}`]
            })

            this.sourceId = filterItem.source_id
        },
        async show(filterIndex, filterItemIndex, externalFilter) {
            this.externalFilter = {...externalFilter}

            this.filterIndex = filterIndex
            this.filterItemIndex = filterItemIndex
            this.externalFilter.uuid = externalFilter.uuid

            this.$refs.Modal.show();
        }
    },
    computed: {
        allLanguagesIsFilled() {
            if (this.externalFilter?.type === 'number') {
                return !!this.names[this.mainLanguageAlias]
            }
            return this.integration.language_aliases.every(languageAlias => !!this.names[languageAlias])
        },
        mainLanguageAlias() {
            return this.integration.language_aliases[0];
        },
        languageAliasesByFilterType() {
            return this.externalFilter?.type === 'number' ? [this.mainLanguageAlias] : this.integration.language_aliases;
        }
    }
}
</script>
